import { render } from "./SalaryEditDialog.vue?vue&type=template&id=b6188a70"
import script from "./SalaryEditDialog.vue?vue&type=script&lang=js"
export * from "./SalaryEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__